import React from 'react';
import { ResourceField, ResourceFormPage } from '../../components/resource/ResourceFormPage';
import { EstoqueMadeira } from '../../types/aquisicao';
import { estoqueMadeiraService, lotesMadeiraService } from '../../services';
import { makeOptionLoader } from '../../utils/optionLoaders';

const fields: ResourceField<EstoqueMadeira>[] = [
  {
    name: 'lote',
    label: 'Lote',
    type: 'async-select',
    valueType: 'number',
    loadOptions: makeOptionLoader(
      lotesMadeiraService.list,
      (item: any) => item.lote_info ?? `Lote ${item.id}`,
    ),
    required: true,
  },
  { name: 'quantidade_disponivel', label: 'Quantidade disponível (ton)', type: 'number' },
  { name: 'quantidade_em_tratamento', label: 'Em tratamento (ton)', type: 'number' },
  { name: 'quantidade_tratada', label: 'Quantidade tratada (ton)', type: 'number' },
  { name: 'localizacao', label: 'Localização' },
  { name: 'observacoes', label: 'Observações', type: 'textarea' },
];

export const EstoqueMadeiraFormPage: React.FC = () => (
  <ResourceFormPage
    title="Atualizar estoque de madeira"
    description="Gerencie o saldo disponível por lote."
    fields={fields}
    service={estoqueMadeiraService}
    redirectPath="/admin/aquisicao/estoque-madeira"
    cancelPath="/admin/aquisicao/estoque-madeira"
  />
);
